module.exports = __webpack_public_path__ + "static/img/qr-code.f59f800.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer/qr-code.png
// module id = i9fi
// module chunks = 14